import { Button, ButtonLink, ListLayout, Modal } from '@ingrid/luterkort-react';

import { LocalizationKey, useTranslation } from '~src/i18n/use-translation';

interface Props {
  clearedItemName: LocalizationKey;
  onSubmit: () => void;
}

export function ClearConfirmationModal(props: Props) {
  const { clearedItemName, onSubmit } = props;
  const { t } = useTranslation();

  return (
    <Modal.Root>
      <Modal.Trigger>
        <ButtonLink>{t('common.clear')}</ButtonLink>
      </Modal.Trigger>

      <Modal.Content>
        <Modal.Header title={t('common.clearConfirmationHeader', { item: t(clearedItemName) })} />

        <Modal.Body>
          <ListLayout.PrimaryText>
            {t('common.clearConfirmationText', { item: t(clearedItemName) })}
          </ListLayout.PrimaryText>
        </Modal.Body>

        <Modal.Footer>
          <ListLayout.SubRow style={{ gap: '1rem' }}>
            <ListLayout.Stack>
              <Modal.CloseButton>
                <Button variant="secondary">{t('common.cancel')}</Button>
              </Modal.CloseButton>
            </ListLayout.Stack>

            <ListLayout.Stack>
              <Button onClick={onSubmit}>{t('common.clear')}</Button>
            </ListLayout.Stack>
          </ListLayout.SubRow>
        </Modal.Footer>
      </Modal.Content>
    </Modal.Root>
  );
}
